import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { fetchClientByClientIdRequest } from '@client/model';
import {
  rateActionApi,
  rateActionKeys,
  type ApplyRateActionOptionBody,
  type ApplyRateActionOptionResponse,
} from '../api/rate-action-api';

export interface UseApplyRateActionOptionParams {
  clientId: string;
  requestId: string;
  onSettled?: () => void;
}

export function useApplyRateActionOption({
  clientId,
  requestId,
  onSettled,
}: UseApplyRateActionOptionParams) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<ApplyRateActionOptionResponse, Error, ApplyRateActionOptionBody>({
    mutationFn: body => rateActionApi.applyOption(body),
    onSuccess: () => {
      // Refresh the rate action record so its new appliedFundingSourceIds map is reflected.
      queryClient.invalidateQueries({ queryKey: rateActionKeys.detail(requestId) });
      // The prior-letters list shows status + appliedFundingSourceIds; apply flips both.
      queryClient.invalidateQueries({ queryKey: rateActionKeys.lists() });
      // Legacy client model still drives the funding-sources page; trigger a reload so the
      // newly-created policy appears there.
      dispatch(fetchClientByClientIdRequest(clientId));
    },
    onSettled,
  });
}
